<div class="d-md-flex pb-2 mb-md-0">
    <div class="d-flex flex-grow-1 mb-2 mb-md-0" ngbDropdown>
        <button class="btn btn-outline-primary" id="showJob" ngbDropdownToggle>{{ showJobs[showJob] | translate }}</button>
        <div ngbDropdownMenu aria-labelledby="showJob">
            <!--button *ngFor="let sj of showJobs; let index=index" class="dropdown-item" (click)="setShowJob(index)">{{ sj }}</button-->
            <a *ngFor="let sj of showJobs | keyvalue" class="dropdown-item" (click)="setJobMode(sj.key)">{{ sj.value | translate }}</a>
        </div>
        <div class="ml-2">
            <form>
                <div class="input-group jobid">
                    <input [(ngModel)]="jobId" name="jobId" type="text" abiProductHint="Job.JobID"/>
                    <div class="input-group-append">
                    <button type="submit" class="btn btn-outline-primary" (click)="searchJob()" [disabled]="!this.jobId">
                        <i class="fas fa-search fa-fw"></i>
                    </button>
                    </div>
                </div>
            </form>
        </div>
    </div>
    <div class="d-flex">
        <abi-table-controls [table]="table" [dataTable]="this">
            <div class="append-menu-items">
                <abi-web-layout [pageId]="pageName" [columns]="columns" [layoutId]="layoutId" [layouts]="layouts" [extras]="layoutExtras.bind(this)">
                </abi-web-layout>
            </div>
        </abi-table-controls>
    </div>
</div>

<div class="table-responsive-md">
    <table
        #table
        [abi-table]="pageName"
        [columns]="columns"
        [rows]="dataList?.items"
        defaultSort="jobId"
        [layoutColumns]="layoutColumns"
        class="table-fixed-md table-hover table-striped table-sm"
        [canFilter]="true"
        [remoteData]="search.bind(this, true)"
        [hiddenColumns]="true"
        [popupOpen]="datePickerOpen"
        [colsObs]="colsObs"
    >

    <ng-template [th]="['statusDescription']" let-column>
        <span class="text-nowrap">{{ column.header | translate }} </span> <br class="d-print-none">
        <div class="input-group mb-1">
            <input type="text" abiTypeahead abiLookup="CodeJobStatus" [ngModel]="column.filter" (ngModelChange)="table.filter(column, $event)" [codeOnly]="true"/>
            <div class="input-group-append">
                <button class="btn btn-outline-primary px-2" (click)="table.filter(column, '')" [disabled]="!column.filter"><i class="fas fa-times"></i></button>
            </div>
        </div>
    </ng-template>
    <ng-template [th]="['repairCodeDescription']" let-column>
        <span class="text-nowrap">{{ column.header | translate }} </span> <br class="d-print-none">
        <div class="input-group mb-1">
            <input type="text" abiTypeahead abiLookup="CodeJobClose" [ngModel]="column.filter" (ngModelChange)="table.filter(column, $event)" [codeOnly]="true"/>
            <div class="input-group-append">
                <button class="btn btn-outline-primary px-2" (click)="table.filter(column, '')" [disabled]="!column.filter"><i class="fas fa-times"></i></button>
            </div>
        </div>
    </ng-template>
    <ng-template [th]="['typeDescription']" let-column>
        <span class="text-nowrap">{{ column.header | translate }} </span> <br class="d-print-none">
        <div class="input-group mb-1">
            <input type="text" abiTypeahead abiLookup="CodeJobType" [ngModel]="column.filter" (ngModelChange)="table.filter(column, $event)" [codeOnly]="true"/>
            <div class="input-group-append">
                <button class="btn btn-outline-primary px-2" (click)="table.filter(column, '')" [disabled]="!column.filter"><i class="fas fa-times"></i></button>
            </div>
        </div>
    </ng-template>
    <ng-template [th]="['sourceDescription']" let-column>
        <span class="text-nowrap">{{ column.header | translate }} </span> <br class="d-print-none">
        <div class="input-group mb-1">
            <input type="text" abiTypeahead abiLookup="CodeJobSource" [ngModel]="column.filter" (ngModelChange)="table.filter(column, $event)" [codeOnly]="true"/>
            <div class="input-group-append">
                <button class="btn btn-outline-primary px-2" (click)="table.filter(column, '')" [disabled]="!column.filter"><i class="fas fa-times"></i></button>
            </div>
        </div>
    </ng-template>
    <ng-template [th]="['contract.typeDescription']" let-column>
        <span class="text-nowrap">{{ column.header | translate }} </span> <br class="d-print-none">
        <div class="input-group mb-1">
            <input type="text" abiTypeahead abiLookup="CodeContractType" [ngModel]="column.filter" (ngModelChange)="table.filter(column, $event)" [codeOnly]="true"/>
            <div class="input-group-append">
                <button class="btn btn-outline-primary px-2" (click)="table.filter(column, '')" [disabled]="!column.filter"><i class="fas fa-times"></i></button>
            </div>
        </div>
    </ng-template>
    <ng-template [th]="['diagnosticCodeDescription']" let-column>
        <span class="text-nowrap">{{ column.header | translate }} </span> <br class="d-print-none">
        <div class="input-group mb-1">
            <input type="text" abiTypeahead abiLookup="CodeJobDiagnostic" [ngModel]="column.filter" (ngModelChange)="table.filter(column, $event)" [codeOnly]="true"/>
            <div class="input-group-append">
                <button class="btn btn-outline-primary px-2" (click)="table.filter(column, '')" [disabled]="!column.filter"><i class="fas fa-times"></i></button>
            </div>
        </div>
    </ng-template>
    <ng-template [th]="['holdTypeDescription']" let-column>
        <span class="text-nowrap">{{ column.header | translate }} </span> <br class="d-print-none">
        <div class="input-group mb-1">
            <input type="text" abiTypeahead abiLookup="CodeHoldType" [ngModel]="column.filter" (ngModelChange)="table.filter(column, $event)" [codeOnly]="true"/>
            <div class="input-group-append">
                <button class="btn btn-outline-primary px-2" (click)="table.filter(column, '')" [disabled]="!column.filter"><i class="fas fa-times"></i></button>
            </div>
        </div>
    </ng-template>

    <ng-template [th]="dateColumns" let-column>
      <span class="text-nowrap d-block text-truncate">{{ column.header | translate }}</span>
      <abi-date-range-filter [initialValue]="column.filter" (changeDate)="table.filter(column, $event)"></abi-date-range-filter>
    </ng-template>

    <ng-template [th]="resourceColumns" let-column>
        <span class="text-nowrap d-block text-truncate">{{ column.header | translate }} </span>
            <abi-select-resource
                class="m-0 d-block mb-1"
                [autoselectFirst]="false"
                [allowClear]="false"
                clearLabel="All"
                [ngModel]="column.filter"
                (ngModelChange)="table.filter(column, $event)"
                placeholder="Select Resource..."
                [codeOnly]="true"
            >
            <div class="input-group-append">
                <button class="btn btn-outline-primary px-2" (click)="table.filter(column, null)" [disabled]="!column.filter"><i class="fas fa-times fa-sm"></i></button>
            </div>
        </abi-select-resource>
    </ng-template>

    <ng-template td="jobId" let-value="value" let-row="row">
        <div class="text-truncate w-99">
            <a [routerLink]="jobLink(row)">{{ row | job:'cleanJobId' }}</a>
        </div>
    </ng-template>
    <ng-template td="resourceId" let-value="value" let-row="row">
      <a href="." (click)="showResource(row.resourceId)">{{ value }}</a>
    </ng-template>
    <ng-template td="visits.0.resourceId" let-value="value">
        <a href="." (click)="showResource(value)">{{ value }}</a>
      </ng-template>
    <ng-template td="" let-value="value" let-row="row">
        <div class="text-truncate w-99">
            {{ value }}
        </div>
    </ng-template>
    <ng-template td="contact" let-value="value" let-row="row">
        <div class="text-truncate w-99">
            <a class="" [routerLink]="jobLink(row)">{{ value }}</a>
        </div>
    </ng-template>
    <ng-template td="contact.mobile" let-value="value">
        <div class="text-truncate w-99">
            <span class="d-md-inline d-none" [abiTelephone]="value"></span>
            <span class="d-inline d-md-none">
                <a class="btn btn-sm btn-outline-secondary text-success" [href]="'tel:' + value">
                    <i class="fas fa-fw fa-phone"></i>
                </a>
            </span>
        </div>
    </ng-template>

    <ng-template td="invoiceCustomer" let-value="value">
      <span [abiTelephone]="value"></span>
    </ng-template>

    <ng-template [td]="['price', 'price-excl', 'price-incl', 'paid', 'unpaid', 'vat-amount']" let-value="value">
        {{ value | nozero: "1.2-2" }}
    </ng-template>
  </table>
</div>

<abi-pager [dataTable]="this"></abi-pager>
